import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoLock = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Lock</title>
    <path
      d="M21.712 11.432V9.556a5.714 5.714 0 1 0-11.427 0v1.876M8.888 11.843H23.11c1.122 0 2.031.963 2.031 2.15v13.984c0 1.188-.91 2.15-2.031 2.15H8.888c-1.122 0-2.032-.962-2.032-2.15V13.994c0-1.188.91-2.151 2.032-2.151Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m16 19.27 1.971 4.93a.571.571 0 0 1-.53.784h-2.883a.571.571 0 0 1-.53-.783l1.971-4.93Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.998 21.556a2.285 2.285 0 1 0 0-4.57 2.285 2.285 0 0 0 0 4.57Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIcoLock;
